import React, { useState, useContext, useCallback, useEffect } from "react";
import { SocketContext } from "./../../context/socket";
import {
  Box,
  Button,
  Divider,
  OutlinedInput,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./index.scss";
import OutsideClickHandler from "react-outside-click-handler";
import Online from "./online";
import { Images } from "./../../assets/common";
import {
  formatedDate,
  getUserDetail,
  getUserId,
  truncate,
} from "./../../constants/function";
import Message from "./Message";
import cookieStorage from "./../../services/cookie-storage";
import NoData from "./../../components/Nodata";
import Loader from "./../../components/Loader";
import Picker from "emoji-picker-react";
import ChatTip from "./ChatTip";
import OnlineUsers from "./OnlineUsers";
import ChatMoreData from "./ChatMoreData";
import { useSelector } from "react-redux";
import ChatInput from "./ChatInput";
import ApiService from "../../services/api-service";
import { useTheme } from "@mui/material/styles";
// Removed SkinTones import - deprecated in v4

export default function Chat(props) {
  console.log('[Chat Performance] Chat component mounting', {
    props,
    timestamp: new Date().toISOString()
  });
  
  const theme = useTheme();
  const songs = useSelector((state) => state.songs);
  const [chosenEmoji, setChosenEmoji] = useState(null);
  const [loading, setLoading] = React.useState(false);
  const token = cookieStorage.getCookie("Authorization");
  const [typing, setTyping] = React.useState(false);
  const socket = useContext(SocketContext).Socket;
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [openEmoji, setOpenEmoji] = useState(false);
  const [error, setError] = useState();
  const [openTip, setOpenTip] = useState(false);
  const [showUsers, setShowUsers] = useState(false);
  const [more, setMore] = useState(false);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [newMessage, setNewMessage] = useState({});
  const [status, setStatus] = useState("active");
  useEffect(() => {
    if (!socket) return; // Add null check
    
    // socket.on("notifyTyping", (msg) => {
    //   if (msg && msg["senderUserId"] && msg["senderUserId"] !== getUserId()) {
    //     setTyping(msg["senderUserId"]);
    //     setTimeout(() => setTyping(false), 500);
    //   }
    // });
    socket.on("blocked", function (data) {
      const userId = getUserId();
      if (data.userId === userId) {
        setStatus(data?.status);
      }
    });
    
    // Cleanup function
    return () => {
      if (socket) {
        socket.off("blocked");
      }
    };
  }, [socket]);

  useEffect(() => {
    if (!socket) {
      return;
    }

    const handleOnlineUsers = (users) => {
      if (Array.isArray(users)) {
        setOnlineUsers([...users]);
      } else {
        setOnlineUsers([]);
      }
    };

    socket.on("onlineuser", handleOnlineUsers);

    return () => {
      socket.off("onlineuser", handleOnlineUsers);
    };
  }, [socket]);

  useEffect(() => {
    console.log('[Chat Performance] Socket effect running', {
      hasSocket: !!socket,
      playListId: props["playListId"]
    });
    // setLoading(true);
    
    if (socket) { // Add null check
      socket.emit("online", {
        JWT: token,
        senderUserId: getUserId(),
        roomId: props["playListId"],
      });
    }
    getBlockedUserOfPlaylist(props["playListId"]);
  }, [socket, token, props["playListId"]]); // Add socket as dependency

  const onEmojiClick = (emojiObject) => {
    if (emojiObject && emojiObject.emoji) {
      setChosenEmoji(emojiObject);
      setMessage((prevMessage) => prevMessage + emojiObject.emoji);
    }
  };
  useEffect(() => {
    return () => {
      if (socket) { // Add null check
        socket.emit("forceDisconnect", {
          JWT: token,
          senderUserId: getUserId(),
          roomId: props["playListId"],
        });
      }
      // before the component is destroyed
      // unbind all event handlers used in this component
    };
  }, [socket, token, props]); // Add proper dependencies
  const getBlockedUserOfPlaylist = async (roomid) => {
    const startTime = performance.now();
    console.log('[Chat Performance] getBlockedUserOfPlaylist started');
    try {
      const response = await ApiService.BLOCKER_USER(roomid);
      console.log('[Chat Performance] getBlockedUserOfPlaylist completed', {
        duration: performance.now() - startTime
      });
      setStatus(response?.result?.isBlocked ? "blocked" : "active");
    } catch (error) {
      console.log('[Chat Performance] getBlockedUserOfPlaylist error', error);
    }
  };
  
  // If socket is not available, show a loading or offline state
  if (!socket) {
    return (
      <Box
        style={{ zIndex: "0" }}
        className={
          "__chat_container" +
          (songs && songs["songs"].length > 0
            ? " __chat_container_with_song"
            : "")
        }
      >
        <Box className={`__chat ${songs && songs.length > 0 ? 'player-open' : ''}`}>
          <Box className="__chat_header">
            <Typography sx={{ color: theme.palette?.text?.secondary || "#5a5a5a" }}>
              Chat is connecting...
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  }
  
  return (
    <Box
      style={{ zIndex: "0", width: "30%", }}
      className={
        "__chat_container" +
        (songs && songs["songs"].length > 0
          ? " __chat_container_with_song"
          : "")
      }
    >
      <Box className={`__chat ${songs && songs.length > 0 ? 'player-open' : ''}`}>
        <Box className="__chat_header">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography
                title={
                  props["title"] && props["title"].length > 25
                    ? props["title"]
                    : ""
                }
                className={"fs-20 text-capitalize"}
                sx={{
                  fontFamily: "var(--font-body)",
                  fontWeight: 700,
                  letterSpacing: "-0.5px",
                  color: theme.palette?.text?.primary || "#FFFFFF"
                }}
              >
                {truncate(props["title"], 25)}
              </Typography>
              {/* <Online
                playListId={props["playListId"]}
                onClick={(onlineUsers) => {
                  setOpenTip(false);
                  setMore(false);
                  setShowUsers(true);
                  setOnlineUsers(onlineUsers);
                }}
                online="true"
                className="_cp"
              /> */}
            </Stack>
            <CloseIcon
              className="_cp"
              onClick={() => props.onOutsideClick()}
              color="default"
            />
          </Stack>
        </Box>
        <Divider className="__chat_header_divider" />
        {!openTip && !showUsers && !more ? (
          <img
            className="_chat_tippers_icon"
            src={Images.chat_drop}
            alt="chat_drop"
            onClick={() => {
              setMore(true);
            }}
          />
        ) : null}
        <Stack sx={{ height: "calc(100% - 30px)" }} spacing={1}>
          <Message
            roomId={props["playListId"]}
            playListId={props["playListId"]}
            newMessage={newMessage}
            type={"group"}
            // clearMsg={() => setNewMessage()}
          />
        </Stack>
        <Box className="__chat_typing">
        </Box>
        {showUsers ? (
          <OnlineUsers
            users={onlineUsers}
            onClose={() => setShowUsers(false)}
          />
        ) : null}
        {openTip ? (
          <ChatTip songs={props["songs"]} onClose={() => setOpenTip(false)} />
        ) : null}
        {more ? (
          <ChatMoreData
            playlistId={props["playListId"]}
            onClose={() => setMore(false)}
          />
        ) : null}
        {openEmoji ? (
          <OutsideClickHandler onOutsideClick={() => setOpenEmoji(false)}>
            <Picker
              onEmojiClick={onEmojiClick}
              searchPlaceHolder="Search emoji..."
              width={350}
              height={400}
              previewConfig={{ showPreview: false }}
            />
          </OutsideClickHandler>
        ) : null}
        {status === "active" ? (
          <Stack direction="row" className="__chat_send">
            <img
              title="Tip"
              aria-label="tip"
              className="__chat_tip _cp"
              src={Images.tip_player}
              alt="tip"
              onClick={() => {
                setShowUsers(false);
                setMore(false);
                setOpenTip(true);
              }}
            />
            <img
              aria-label="emoji"
              title="Open emoji"
              className="_cp"
              style={{ width: "26px" }}
              src={Images.emoji}
              alt="emoji"
              onClick={() => {
                setOpenEmoji(true);
                setShowUsers(false);
                setMore(false);
                setOpenTip(false);
              }}
            />
            <ChatInput
              message={message}
              playListId={props["playListId"]}
              onSendMessage={(msg) => {
                setNewMessage({ ...msg });
                setMessage("");
              }}
              cleanEmoji={() => setMessage("")}
            />
          </Stack>
        ) : (
          <Stack
            direction="row"
            justifyContent="center"
            align="center"
            className="__chat_send"
          >
            <Typography
              sx={{
                color: "#5a5a5a",
                display: "flex",
                alignItems: "center",
                cursor: "default",
              }}
            >
              Blocked
            </Typography>
          </Stack>
        )}
      </Box>
    </Box>
  );
}
